<template>
<div>

  <button  @click="$emit('close')" id="close" class="btn  btn-secondary  btn-block  mb-1"  href="#chiudi">
              <i  style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
              {{ btn_text }}                          
</button> 
 <div class="card border-info">

 <div class="card-header bg-light border-info" >
   

<product-info v-bind:productId="product.productId"></product-info>
</div>

  <div class="card-body">


<div class="row ">
  <div class="col-md-2 ">
        
    <div class="nav flex-column nav-pills nav-fill" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a @click="toggleTab(index)" v-for="(item,index) in nav_buttons" class="nav-link text-nowrap_ text-left" :class="item.active == 1 ? ' active' : ''" href="#">         
            <i class="icon mr-3" :class="item.icon" aria-hidden="true"></i>
            {{ item.text }}
        </a>

    </div>

    

  </div>
  <div class="col-md-10 ">
    <div class="tab-content ml-3" id="v-pills-tabContent">     
        <component v-bind:is="component" v-bind:item="product" @sendData="setData"  v-bind:btn="true" />   
      
    </div>
  </div>
</div>

      
</div>
</div>
</div>
</template>

<script>


import productInfo        from '@/components/product/ProductInfo.vue';

import tab1               from '@/components/backOffice/ready/tab/ProductUpdate.vue' 
import tab2               from '@/components/backOffice/ready/tab/PrintBarcodes.vue' 
import tab3               from '@/components/backOffice/ready/tab/PriceList.vue' 
import tab4               from '@/components/backOffice/ready/tab/SupplierColor.vue' 
import tab5               from '@/components/backOffice/ready/tab/ColorSwapping.vue' 
import tab6               from '@/components/product/productStock.vue'
import tab7               from '@/components/backOffice/ready/tab/ProductStoreStockQtyUpdate.vue'  

import tab8               from '@/components/backOffice/ready/tab/MovementPivot.vue' 
import tab9               from '@/components/common/ProductPivot.vue'
import tab10              from '@/components/backOffice/ready/tab/ProductMarketPlace.vue' 
import tab11              from '@/components/common/ProductGallery.vue' 
import tab12              from '@/components/backOffice/ready/tab/SupplierBarcodes.vue'
import tab13              from '@/components/backOffice/ready/tab/CustomLabelUpdate.vue'
import tab14              from '@/components/product/GestioneAttributi.vue'





export default { 
  components: { productInfo,tab1,tab2,tab3,tab4,tab5,tab6,tab7,tab8,tab9,tab10,tab11,tab12,tab13,tab14 },
  name: '',
  props :  {product:{type:Object}
            ,btn_text:{type:String,default:'RITORNA A LISTA PRODOTTI'}
        },


   data () {
      return {
        component    : "tab1",
        components   : ['tab1','tab2','tab3','tab4','tab5','tab6','tab7','tab8','tab9','tab10','tab11','tab12','tab13','tab14'],
        nav_buttons  : [{text:'ANAGRAFICA',icon:'fas fa-book',active:1},
        {text:'STAMPA ETICHETTE',icon:'fas fa-print',active:0},
        {text:'LISTINO DI VENDITA',icon:'far fa-list-alt',active:0},
        {text:'COLORE GESTIONALE/FORNITORE',icon:'fas fa-palette',active:0},
        {text:'SOSTITUZIONE COLORE',icon:'fas fa-sync-alt',active:0},
        {text:'ESISTENZA',icon:'fas fa-database',active:0},
        {text:'MODIFICA ESISTENZA',icon:'far fa-edit',active:0},
        {text:'PIVOT MOV. ANALITICO',icon:'fas fa-tasks',active:0},
        {text:'PIVOT MOV. SINTETICO',icon:'fas fa-th-list',active:0},
        {text:'PUBBLICA PRODOTTO',icon:'fas fa-globe',active:0},
        {text:'GALLERY',icon:'fas fa-camera',active:0},
        {text:'ASSOCIAZIONE BARCODE FORNITORE',icon:'fas fa-bars',active:0},
        {text:'PREZZO,SCONTO ETICHETTA PROMO',icon:'fas fa-tag',active:0},
        {text:'GESTIONE ATTRIBUTI',icon:'fas fa-tshirt',active:0}
       ],
        
       
      
      
      }
        
    },
    created()
    {
      //console.log('Prod',this.product)
    },
  
    methods: 
    {

      setData(msg)
      {
        
        this.$emit('refreshProductList',msg)
      },
      toggleTab(index)
      {
        this.nav_buttons.forEach(item =>{
          item.active = 0  
        })
        this.nav_buttons[index].active = 1

        this.component = this.components[index]
      
      } 
    },

      
    
    
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.nav-pills .nav-link.active {
    font-family         : 'Roboto Condensed';
    background-color    : rgb(44, 119, 232);
    color               : white;
    font-style: oblique;
    
}

.nav-pills .nav-link:not(.active) {
    font-family         : 'Roboto Condensed';
    background-color: white;
    color: rgb(31, 109, 70);
}

.nav-pills .nav-link.active .icon
{
  
  color: yellow;
}

.nav-pills .nav-link:not(.active)
{
  
  color:black;
}

.nav-pills .nav-link:not(.active) .icon
{
  
  color:cornflowerblue;
}

.bg-light{
  background-color : #4097ee22 !important;
}

.nav :not(active) {

_font-weight      : bold; 
color            : black;

  
}


</style>
